// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5b15ef2b","239":"7051396a","634":"a0964b4f"}[chunkId] + ".chunk.js";
};